import { Pipe, PipeTransform, OnDestroy, Inject, LOCALE_ID, ChangeDetectorRef  } from '@angular/core';
import { CurrencyFacade } from '../../../data-access/services/currency/services/currency.facade';
import { Observable, Subject, catchError, map, of, takeUntil } from 'rxjs';
import { LocalStorageUtil } from '../../../ui/utils/local-storage.utils';
import { CURRENCY_RATES_LOCAL_STORAGE_KEY, CURRENT_CURRENCY_TYPE_LOCAL_STORAGE_KEY } from '../../../data-access/services/currency/consts/currency.consts';

@Pipe({
  name: 'currencyConverter',
  // pure: false // Important for reacting to external changes
})
export class CurrencyConverterPipe implements PipeTransform, OnDestroy {

  private destroy$ = new Subject<void>();
  previousCurrency: string = 'USD';
  currentCurrency: string = 'USD';
  exchangeRate: number;

  constructor(private currencyFacade: CurrencyFacade, @Inject(LOCALE_ID) private locale: string, private cdr: ChangeDetectorRef) {
  }

  transform(value: any, args?: any): string {
    const currentCurrencyType = LocalStorageUtil.getOption(CURRENT_CURRENCY_TYPE_LOCAL_STORAGE_KEY);
    const multiplyValue = LocalStorageUtil.getOption(CURRENCY_RATES_LOCAL_STORAGE_KEY)?.exchangeRate[currentCurrencyType];
    let convertedValue = value;
    if( multiplyValue !== undefined ) {
      convertedValue = value * multiplyValue;
    }
    if(currentCurrencyType !== undefined && currentCurrencyType !== 'USD' ) {
      return `${this.getCurrencySymbol(currentCurrencyType)}${convertedValue.toFixed(2)}`;
    } else{
      return `${this.getCurrencySymbol(this.currentCurrency)}${value}`;
    }
  }

  private getCurrencySymbol(currencyCode: string): string {
    try {
      // Use Angular's built-in currency pipe to obtain the currency symbol dynamically based on the currency code
      const formattedCurrency = 1; // Dummy value to format
      const formattedValue = new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: currencyCode
      }).format(formattedCurrency);
      // Extract and return the currency symbol from the formatted value
      return formattedValue.replace(/[0-9.,\s]/g, '');
    } catch (error) {
      console.error('Error getting currency symbol:', error);
      return ''; // Default to empty string if an error occurs
    }
  }

  updatePipe() {
    this.cdr.markForCheck(); // Mark component for change detection
    this.cdr.detectChanges(); // Detect changes in the component
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
